import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { addComment }from '../../actions';
import {renderInput} from '../forms/newcaso/Fields'

class CommentForm extends Component{
    renderField(field){
        return(
                <input
                    placeholder={field.placeholder}
                    className="form-control"
                    type={field.type}
                    {...field.input}
                />
        )
    }
    onSubmit(values){
        console.log(values);
        values.caso_id = this.props.caso_id;
        this.props.reset();
        this.props.addComment(values);
    }
    render(){
        const { handleSubmit } = this.props;

        return(
        <div className="comment-textinput">
                <form className="row no-gutters" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                    <div className="input-group">
                    <Field
                        placeholder="Comentario"
                        name="comment"
                        ref="inputComment"
                        component={this.renderField}
                    />
                    <span className="input-group-btn">
                        <button type="submit" className="btn btn-info"><i className="text-white fa fa-send" /></button>
                    </span>
                    </div>
                </form>
            </div>
        )
    }
}

CommentForm = reduxForm({
    form: 'addComment',
    fields: ['comment']
})(CommentForm);

export default CommentForm = connect(null, { addComment })(CommentForm);


// WEBPACK FOOTER //
// ./resources/assets/js/components/comments/CommentForm.jsx